const dispatch = (eventType: string, data: any) => {
    const event = new CustomEvent(eventType, { detail: data });
    window.dispatchEvent(event);
}

const EventDispatcher = { dispatch };

export default EventDispatcher;
